import { Injectable } from '@angular/core';
import { RecurrenceLogMapped } from '@core/interfaces';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class UpdatedByLogService {
  private readonly customAuthorDeviceMapper = Object.freeze({
    mountdoom: 'laptop',
    mordor: 'laptop',
    lorgan: 'upload',
    gorgoroth: 'smartphone',
    system: 'settings',
  });

  constructor(private translateService: TranslateService) { }

  public customUpdatedByInLogs(logs: RecurrenceLogMapped[]): RecurrenceLogMapped[] {
    for (let log of logs) {
      log = this.generateUpdateByLog(log);
    }

    return logs;
  }

  private generateUpdateByLog(log: RecurrenceLogMapped): RecurrenceLogMapped {
    const typeLog = log.isCreatedLog ? 'CREATED' : 'UPDATED';
    const authorName = (log.updatedBy && log.updatedBy.name) || log.updatedByName;
    const clientApplicationName = (log.clientApplicationName || 'mountdoom').toUpperCase();

    log.customAuthorDevice = this.customAuthorDeviceMapper[clientApplicationName.toLowerCase()];

    if (log.clientApplicationName === 'mordor') {
      log.customAuthor = [
        this.translateService.instant(`RECURRENCES.DIALOG.TABS.HISTORIC.AUTHOR.${typeLog}`),
        authorName
          ? this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.AUTHOR.BY_COMPANY', { authorName })
          : this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.AUTHOR.DEVICES.SYSTEM'),
      ].filter(Boolean).join(' ');

      return log;
    }

    log.customAuthor = [
      this.translateService.instant(`RECURRENCES.DIALOG.TABS.HISTORIC.AUTHOR.${typeLog}`),
      authorName ? this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.AUTHOR.BY_AUTHOR', { authorName }) : null,
      this.translateService.instant(`RECURRENCES.DIALOG.TABS.HISTORIC.AUTHOR.DEVICES.${clientApplicationName}`)
    ].filter(Boolean).join(' ');

    return log;
  }
}
